var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22482_6338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.72453 20.185C2.91722 17.9805 1.92188 15.1963 1.92188 12.3456V4.46875C1.92188 4.28228 1.99594 4.10341 2.1278 3.97155L5.40905 0.690297C5.54095 0.558438 5.71978 0.484375 5.90625 0.484375H18.0938C18.2802 0.484375 18.4591 0.558438 18.591 0.690297L21.8722 3.97155C22.0041 4.10341 22.0781 4.28228 22.0781 4.46875V12.3456C22.0781 15.1964 21.0828 17.9805 19.2755 20.185C17.4681 22.3896 14.9333 23.9117 12.1379 24.4707C12.0468 24.4889 11.9531 24.4889 11.8621 24.4707C9.0667 23.9117 6.53189 22.3896 4.72453 20.185Z",
    fill: "url(#paint0_linear_22482_6338)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0596 5.13658L17.4258 3.50284C17.294 3.37094 17.1151 3.29688 16.9287 3.29688H7.07123C6.88477 3.29688 6.70594 3.37094 6.57408 3.5028L4.9403 5.13653C4.80844 5.26839 4.73438 5.44722 4.73438 5.63373V12.3456C4.73438 16.6629 7.64738 20.4576 11.8182 21.5738C11.9373 21.6057 12.0627 21.6057 12.1818 21.5738C16.3526 20.4576 19.2656 16.6629 19.2656 12.3456V5.63373C19.2656 5.44727 19.1915 5.26844 19.0596 5.13658ZM15.5631 9.77073L10.9227 14.4111C10.6481 14.6857 10.203 14.6857 9.92836 14.4111L8.43684 12.9196C8.16225 12.645 8.16225 12.1998 8.43684 11.9252C8.71144 11.6506 9.15661 11.6506 9.4312 11.9252L10.4256 12.9196L14.5687 8.77637C14.8433 8.50178 15.2885 8.50178 15.5631 8.77637C15.8377 9.05097 15.8377 9.49614 15.5631 9.77073Z",
    fill: "url(#paint1_linear_22482_6338)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22482_6338",
    x1: 1.92188,
    y1: 12.4844,
    x2: 22.0781,
    y2: 12.4844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B71F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FB5F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22482_6338",
    x1: 4.73438,
    y1: 12.4473,
    x2: 19.2656,
    y2: 12.4473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1CBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBE2FD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22482_6338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.484375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateIcon);
export default __webpack_public_path__ + "static/media/private-icon.2d2b466af6e19e17db9ecdf185eaca4b.svg";
export { ForwardRef as ReactComponent };